export default __webpack_public_path__ + "static/media/093-expand.83f8bf90.png";